<template>
  <div class="footer">
    <div class="content">
      <div class="row">
        <div class="col">
          <ul>
            <li class="title">友情链接</li>
            <li
              class="beyondEllipsis item"
              v-for="(item, index) in leftList"
              :key="index"
            >
              <a style="color: #fff" :href="item.url" target="_blank">{{
                item.linkName
              }}</a>
            </li>
          </ul>
        </div>
        <div class="col">
          <ul>
            <li class="title">联系方式</li>
            <li class="item">
              <i class="el-icon-location"></i>
              地址：{{ centerList.addr }}
            </li>
            <li class="item">
              <i class="el-icon-s-promotion"></i>
              邮编：{{ centerList.zipCode }}
            </li>
            <li class="item">
              <i class="el-icon-phone"></i>
              联系电话：{{ centerList.lMobile }}
            </li>
            <li class="item">
              <i class="el-icon-s-promotion"></i>
              学报投稿邮箱：yy58556822@sina.com
            </li>
          </ul>
        </div>
        <div class="col">
          <ul>
            <li class="title">内部网</li>
            <li
              class="beyondEllipsis item"
              v-for="(item, index) in rightList"
              :key="index"
            >
              <a style="color: #fff" :href="item.url" target="_blank">{{
                item.linkName
              }}</a>
            </li>
          </ul>
        </div>
        <div class="col">
          <div class="qrCode">
            <img src="@/assets/img/Android.png" width="100%" />
            <p>手机端</p>
          </div>
          <!-- <div class="qrCode" style="top:150px;">
            <img src="@/assets/img/Ios.png" width="100%" />
            <p>苹果客户端</p>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { friendlyLink_qy, organ_qy } from "@/api/home";
export default {
  data() {
    return {
      leftList: [],
      centerList: {},
      rightList: [],
    };
  },
  mounted() {
    this.getLink();
    this.getCenterList();
    this.getRightList();
  },
  methods: {
    getLink() {
      friendlyLink_qy({ op: "findFriendlyLink", propertys: 0 }).then((res) => {
        res.map((res) => {
          if (res.url.indexOf("www.") == 0) {
            res.url = "http://" + res.url;
          }
        });
        this.leftList = res;
      });
    },
    getCenterList() {
      organ_qy({ op: "getRootOrgan" }).then((res) => {
        this.centerList = res;
      });
    },
    getRightList() {
      friendlyLink_qy({ op: "findFriendlyLink", propertys: 1 }).then((res) => {
        res.map((res) => {
          if (res.url.indexOf("www.") == 0) {
            res.url = "http://" + res.url;
          }
        });
        this.rightList = res;
      });
    },
  },
};
</script>

<style scoped lang="less">
.footer {
  min-height: 300px;
  background: url("~@/assets/img/footerBg.png") no-repeat;
  background-size: 100% 100%;
  margin-top: 50px;
  .content {
    width: 1200px;
    margin: 0 auto;
    padding-top: 50px;
    color: #fff;
    .title {
      margin-bottom: 25px;
    }
    .item {
      line-height: 30px;
      font-size: 14px;
      max-width: 300px;
    }
  }
  .qrCode {
    width: 112px;
    font-size: 14px;
    text-align: center;
    display: inline-block;
  }
}
.row {
  display: flex;
  justify-content: space-around;
}
</style>